export const dataSets = {
  configuration: {
    createDataSet: "Create DataSet"
  }
};
